import { styled } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  display: 'flex',
  gap: 12,
}));
